import { render } from "./PasswordReset.vue?vue&type=template&id=47b937c7&scoped=true&ts=true"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import "./PasswordReset.vue?vue&type=style&index=0&id=47b937c7&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b937c7"]])

export default __exports__